import { Link } from "react-router-dom";
import { Phone, Mail, Facebook, Clock } from "lucide-react";
import { BRAND, SERVICES } from "@/data/content";

export default function Footer() {
  return (
    <footer
      className="bg-[#1c1917] text-[#fdfbf7] mt-16"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logo}
                alt="ProCraft Solutions"
                className="h-14 w-14 rounded-xl object-cover ring-1 ring-white/10"
              />
              <div>
                <div className="font-display font-black text-2xl">
                  ProCraft <span className="text-[#16a34a]">Solutions</span>
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-white/60">
                  Build Smart. From The Start.
                </div>
              </div>
            </div>
            <p className="mt-5 text-white/70 max-w-md leading-relaxed">
              Locally owned and operated. Reliable, high-quality property
              service for residential and commercial properties across the Tampa
              Bay area.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href={BRAND.facebook}
                target="_blank"
                rel="noreferrer"
                className="h-11 w-11 inline-flex items-center justify-center rounded-full border border-white/15 hover:bg-[#16a34a] hover:border-[#16a34a] transition"
                data-testid="footer-facebook"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-white/75 hover:text-[#eab308] transition text-sm"
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-bold text-lg mb-4">Get In Touch</h4>
            <ul className="space-y-3.5 text-sm">
              <li>
                <a
                  href={BRAND.phoneHref}
                  className="flex items-center gap-3 text-white/85 hover:text-[#16a34a] transition"
                  data-testid="footer-phone"
                >
                  <span className="h-9 w-9 inline-flex items-center justify-center rounded-full bg-white/5">
                    <Phone className="w-4 h-4" />
                  </span>
                  {BRAND.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="flex items-center gap-3 text-white/85 hover:text-[#16a34a] transition break-all"
                  data-testid="footer-email"
                >
                  <span className="h-9 w-9 inline-flex items-center justify-center rounded-full bg-white/5 flex-none">
                    <Mail className="w-4 h-4" />
                  </span>
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BRAND.email2}`}
                  className="flex items-center gap-3 text-white/85 hover:text-[#16a34a] transition break-all"
                  data-testid="footer-email-2"
                >
                  <span className="h-9 w-9 inline-flex items-center justify-center rounded-full bg-white/5 flex-none">
                    <Mail className="w-4 h-4" />
                  </span>
                  {BRAND.email2}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/85">
                <span className="h-9 w-9 inline-flex items-center justify-center rounded-full bg-white/5">
                  <Clock className="w-4 h-4" />
                </span>
                Mon – Fri · 8 AM – 5 PM
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-white/55">
          <div>© {new Date().getFullYear()} ProCraft Solutions. All Rights Reserved.</div>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link
              to="/privacy-policy"
              className="hover:text-[#16a34a] transition"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <span className="text-white/25">·</span>
            <Link
              to="/terms-and-conditions"
              className="hover:text-[#16a34a] transition"
              data-testid="footer-terms-link"
            >
              Terms &amp; Conditions
            </Link>
          </div>
          <div>Tampa Bay, Florida · Licensed &amp; Insured · Lic. #L23000070666</div>
        </div>
      </div>
    </footer>
  );
}
